// Scoped loggers for the renderer process
// Remote app uses console-based logging instead of electron-log
export const rendererLog = {
  info: (...args: unknown[]) => console.info('[renderer]', ...args),
  warn: (...args: unknown[]) => console.warn('[renderer]', ...args),
  error: (...args: unknown[]) => console.error('[renderer]', ...args),
  debug: (...args: unknown[]) => console.debug('[renderer]', ...args),
}

export const searchLog = {
  info: (...args: unknown[]) => console.info('[search]', ...args),
  warn: (...args: unknown[]) => console.warn('[search]', ...args),
  error: (...args: unknown[]) => console.error('[search]', ...args),
  debug: (...args: unknown[]) => console.debug('[search]', ...args),
}

export default { scope: (name: string) => ({
  info: (...args: unknown[]) => console.info(`[${name}]`, ...args),
  warn: (...args: unknown[]) => console.warn(`[${name}]`, ...args),
  error: (...args: unknown[]) => console.error(`[${name}]`, ...args),
  debug: (...args: unknown[]) => console.debug(`[${name}]`, ...args),
}) }
